import { ANALYTICS_EVENT_NAMES } from '../../constants';
import { analyticsBrowser } from '../../clients';
import toSnakeCase from 'lodash/snakeCase';

function trackUserEnteredInput(event) {
  if (event?.type !== 'blur') {
    return;
  }

  // Wrapping in a try/catch to avoid errors when the event target is not the expected type.
  try {
    const target = event.target;
    const element = target.closest('[data-analytics-element-id]');
    const elementId = element?.getAttribute('data-analytics-element-id');

    if (!element || !elementId) {
      return;
    }

    const metadata = element
      .getAttributeNames()
      .reduce((accumulatedMetadata, key) => {
        const value = element.getAttribute(key);
        const isMetadata = key.startsWith('data-analytics-metadata-') && value;

        if (!isMetadata) {
          return accumulatedMetadata;
        }

        accumulatedMetadata[
          toSnakeCase(key.replace('data-analytics-metadata-', ''))
        ] = value;
        return accumulatedMetadata;
      }, {});

    const trackedProperties = {
      element_id: elementId,
      element_type: element.tagName.toLowerCase(),
      input_action: event.type,
      input_state: element.value ? 'filled' : 'empty',
      input_type: element.type,
      is_input_masked: false,
      metadata,
      page_path: window.location.pathname,
    };

    analyticsBrowser.track(
      ANALYTICS_EVENT_NAMES.userEnteredInput,
      trackedProperties
    );
  } catch (error) {
    // Do nothing.
  }
}

export default trackUserEnteredInput;
